import type { DialogProps } from '@_/ui';
import type { CourseListFilterSchema } from './schema.ts';
import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { FilterDialogContent } from '@_/components';
import { labelCommonI18n } from '@_/i18n-common';
import { withDialog, StackedLayout, StackedLayoutSection } from '@_/ui';
import { CurriculumFilter } from '#src/components/filters/CurriculumFilter.tsx';
import { DistrictFilter } from '#src/components/filters/DistrictFilter.tsx';
import { labelI18n } from '#src/i18nMessages/index.ts';

export const CourseListFilterDialog = withDialog(
  {},
  function CourseListFilterDialogContent({
    onOpenChange,
    onSuccess,
    showCurriculumFilter = true,
    value
  }: Pick<DialogProps, 'onOpenChange'> & {
    onSuccess?: (value: CourseListFilterSchema) => void;
    showCurriculumFilter?: boolean;
    value: CourseListFilterSchema;
  }) {
    const [internalValue, setInternalValue] = useState(value);

    const submit = () => {
      onOpenChange(false);
      onSuccess?.(internalValue);
    };

    const reset = useCallback(() => {
      setInternalValue({
        academicLevelIds: [],
        countryZoneCodes: [],
        curriculumIds: []
      });
    }, []);

    return (
      <FilterDialogContent onReset={reset} onSubmit={submit}>
        <StackedLayout size="sm">
          <StackedLayoutSection heading={<FormattedMessage {...labelI18n.districts} />} initialOpen>
            <DistrictFilter
              onChange={useCallback(countryZoneCodes => {
                setInternalValue(prev => ({ ...prev, countryZoneCodes }));
              }, [])}
              value={internalValue.countryZoneCodes}
            />
          </StackedLayoutSection>

          {showCurriculumFilter && (
            <StackedLayoutSection
              heading={<FormattedMessage {...labelCommonI18n.curriculum} />}
              initialOpen
            >
              <CurriculumFilter
                onChange={({ academicLevelIds, curriculumIds }) => {
                  setInternalValue(prev => ({
                    ...prev,
                    academicLevelIds,
                    curriculumIds
                  }));
                }}
                value={{
                  academicLevelIds: internalValue.academicLevelIds,
                  curriculumIds: internalValue.curriculumIds
                }}
              />
            </StackedLayoutSection>
          )}
        </StackedLayout>
      </FilterDialogContent>
    );
  }
);
